import { useState } from "react";
import { useTranslation } from "react-i18next";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import {
  ExportRatingsReportForExcelPDFBody,
  Rating,
} from "../../../hooks/report/interface";
import SearchRatingsReportCard from "../../../components/card/SearchRatingsReportCard";
import RatingsReportTable from "../../../components/table/RatingsReportTable";
import { PAGE_SIZE } from "../../../constants/common";

const RatingsReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportRatingsReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allRatings, setAllRatings] = useState<Rating[]>([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl  dark:text-white">
          {t("ratingsReport")}
        </h1>
      </BackButtonWrapper>

      <SearchRatingsReportCard
        setAllRatings={setAllRatings}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <RatingsReportTable
        allRatings={allRatings}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default RatingsReport;
